import { UIService } from './../../ui.service';
import { AuthService } from '../auth.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor(private authService: AuthService, public uiService:UIService) { }

  ngOnInit() {
  }
  onLogin(user) {
    this.authService.login(user);
  }
}
